import Vue from 'vue'

export default {
	list({}, filter) {
		return Vue.api.post('comment/list', {
			"per_page": filter.per_page || 5,
			"current_page": filter.current_page || 1,
			"obj_id": filter.id,
			"mark": filter.stars,
			"status": 'verified',
			"obj_type": filter.obj_type || "user",
			"type": "review"
		}).then(result => result.data)
	},
	get ({}, id) {
		return Vue.api.get('comment/' + id)
	},
	create({}, model) {
		return Vue.api.post('comment/', {
			"obj_id": model.obj_id,
			"title": model.title,
			"text": model.text,
			"mark": model.stars,
			"type": "review",
			"obj_type": model.obj_type || "user"
		})
	},
	update({}, model) {
		return Vue.api.put('comment/' + model._id, {
			"obj_id": model.obj_id,
			"title": model.title,
			"text": model.text,
			"mark": model.stars,
			"type": "review",
			"obj_type": "user"
		})
	},
	delete({}, id) {
		return Vue.api.delete('comment/' + id)
	},
	reply({}, model) {
		return Vue.api.post('comment/', {
			parent_id: model.parent_id,
			obj_id: model.obj_id,
			text: model.text,
			obj_type: 'user',
			type: 'comment'
		})
	}
}



// WEBPACK FOOTER //
// ./src/vuex/services/review/actions.js